<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="template-padding" v-else-if="loaded" > 
        <div class="row" >
            <div class="col-10" >
                <b-input-group>
                    <b-form-input v-model="filter" placeholder="Search watchers" class="search-input atlass-input-borderless" />
                    <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                </b-input-group>
            </div>
            <div class="col-2 text-right" >
                <a @click="CreateItem" class="btn btn-primary btn-sm" >  Create <font-awesome-icon icon="plus" class="ml-1" /> </a>
            </div>
        </div>
        
        <vue-good-table
            class=""
            :columns="columns"
            :rows="rows"
            styleClass="vgt-table atlass-datatable"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="{ 
                enabled: true,
                perPage: 20,
                perPageDropdown: [50, 100],
                ropdownAllowAll: true,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Watchers per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            }"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"

             >
            
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                    
                  <a class="mr-3" @click="routeRow(props.row.id)"> <font-awesome-icon icon="edit" /> </a>
                  <a class="mr-2" @click="deleteRow(props.row.id)"> <font-awesome-icon icon="trash-alt" /> </a>
                </span>
                <span v-else  >
                  {{props.formattedRow[props.column.field]}}
                </span>
            </template>
            
        </vue-good-table>
          
        <!--
        <div class="modal-dimmer" v-if="modalState" @click="fModalClose()" ></div>
        <div v-bind:class="[{ 'open': modalState }, 'atlass-modal ']" >
            <div class="atlass-modal-close" > <a @click="fModalClose()" > <font-awesome-icon icon="times"  /> </a> </div>
            <watcherComponent v-if="modalState" :ID="modalData" ></watcherComponent>
        </div>
        -->

        <modal :modalData="modalData" :modalState="modalState" modalComponent="watcher" modalClass="narrow" ></modal>
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
    
import modal from '@/components/modal.vue'    
import helper from '@/helpers/helpers.js';
    
export default{
    name: "Watchers",
    components:{
        modal
    },
    data () {
        return {
            filter: '',
            columns: [
                {
                    label: 'NAME',
                    field: 'name'
                },
                {
                    label: 'PARAMETER TO WATCH',
                    field: 'parameter'
                },
                {
                    label: 'CREATED',
                    field: this.returnDate,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                {
                    label: 'ACTION',
                    field: 'actions',
                    sortable: false,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
            ],
            rows: [],
            loaded: false,
            modalData: null,
            modalState: false,
            loggedOrgID: null
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        this.loggedOrgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
        this.get_data();
        
    },
    computed: {
    },
    methods: {
        get_data(){
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+this.loggedOrgID+'/watchers').orderBy('datetime', 'desc')

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                            
                                results.push(item);     
                                //console.log( item )

                                //results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.rows = results


                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        returnName(a){
            return a.firstname + " " + a.lastname;
        },
        returnDate(a){
            //return this.$moment.unix(a.datetime).format( 'MMM D, HH:mm' )
             return helper.formatDate( a.datetime, 'MMM D, HH:mm' )
        },
        renderStatus(a){
            var r;
            
            if( a.Status == 1 ){
                r = 'Active';
            }else if( a.Status == 0 ){
                r = 'Inactive';
            }else if( a.Status == 2 ){
                r = 'Blocked';
            }else if( a.Status == 3 ){
                r = 'Manually blocked';
            }
            
            return r;
        },
        routeRow(id){
            this.fModalOpen( id );
            
        },
        deleteRow(id){
            //this.fModalOpen( params.row.id );
            this.PreventDelete(id)
        },
        CreateItem(){
            this.fModalOpen( null );
            
        },
        fModalOpen( data ){
            this.modalState = true;
            this.modalData = data
        },
        PreventDelete( ID ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete(ID);
                    
                }
            })
            
        },        
        delete: function(ID){
            
            this.loaded = false
            
            const db = firebase.firestore();
            let ref = db.collection('organizations/'+this.loggedOrgID+'/watchers').doc( ID )
            return ref.delete()
                .then(function(){
                
                     this.$toast.success({
                        title: 'Success',
                        message: 'Watcher deleted'
                    })

                    setTimeout(function(){ 
                        this.loaded = true
                        this.get_data();
                        this.modalData = null
                        this.modalState = false
                    }.bind(this), this.timeout );
                
                }.bind(this))
                .catch(function(error){
                
                    //console.error("Error updating document: ", error);
                    this.$toast.error({
                        title: 'Error',
                        message: "Something went wrong: "+error
                    })
                
                    this.loaded = true
                
                }.bind(this))
        }
    },
    computed:{
        getUserEmail(){
            return this.$store.getters.getUserEmail
        },
        getOrganizationID(){
            return this.$store.getters.getOrganizationID
        },
    },
}
</script>

<style >
    
</style>


// WEBPACK FOOTER //
// src/templates/setup/Watchers.vue